import type { MouseEvent, ReactElement } from 'react';
import { Stack, type StackProps, Typography } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

interface IMenuButtonProps {
  icon: ReactElement;
  text?: string;
  content?: ReactElement;
  active?: boolean;
  disabled?: boolean;
  onClick?: (event: MouseEvent<HTMLElement>) => void;
  isSmall?: boolean;
  StackProps?: StackProps;
  isExternalLink?: boolean;
}

export const MenuButton = ({
  icon,
  text,
  active,
  disabled,
  onClick,
  content,
  isSmall = false,
  StackProps,
  isExternalLink,
}: IMenuButtonProps) => {
  return (
    <Stack
      direction={'row'}
      alignItems="center"
      justifyContent={'flex-start'}
      px={2}
      py={1}
      borderRadius={1}
      gap={isSmall ? 0 : 1}
      color={(theme) =>
        active
          ? theme.palette.getContrastText(theme.palette.primary.main)
          : theme.palette.primary.main
      }
      bgcolor={(theme) => (active ? theme.palette.primary.main : undefined)}
      sx={{
        cursor: 'pointer',
        '&:hover':
          disabled || active ? undefined : { bgcolor: (theme) => theme.palette.neutral[200] },
        transition: 'all 0.3s ease',
      }}
      onClick={onClick}
      {...StackProps}
    >
      {icon}

      <Stack
        maxWidth={isSmall ? 0 : 200}
        direction={'row'}
        overflow={'hidden'}
        sx={{ transition: 'all 0.3s ease' }}
        alignItems={'center'}
        gap={1}
      >
        {!!text && (
          <>
            <Typography align="center" whiteSpace={'nowrap'} fontSize={'0.8em'}>
              {text}
            </Typography>

            {!!isExternalLink && <OpenInNewIcon sx={{ fontSize: 16 }} />}
          </>
        )}

        {!!content && content}
      </Stack>
    </Stack>
  );
};
